module.exports = __webpack_public_path__ + "img/list.76dedeca.svg";